import snabbdom from '@servicenow/ui-renderer-snabbdom';

export default snabbdom;
